export default __webpack_public_path__ + "static/media/dealsoweek_hells.255afa5a.png";